import React, { useEffect } from 'react';

import { useFirePostOfficeTrigger } from '@atlassian/post-office-context';

export const PostOfficeHtmlTarget = ({
	id,
	children,
}: {
	id: string;
	children: React.ReactNode;
}): React.JSX.Element => {
	const { fireTrigger } = useFirePostOfficeTrigger({ triggerId: id });

	useEffect(() => {
		fireTrigger({ isActive: true });

		return () => {
			fireTrigger({ isActive: false });
		};
	}, [fireTrigger]);

	return <div id={id}>{children}</div>;
};
